import {pad} from "lodash";

export  const padding = (nmb:number, max:number) =>{
    const str = nmb.toString();
    return str.length < max ? pad("0" + str, max) : str;
}
export  const generateRandomNumber = (min:number,max:number)=>{
    return  Math.floor(Math.random() * (max - min + 1)) + min;
}